import { Setting } from "../components/setting";
import { ABBREVIATIONS, ABBREVIATIONS_ALL } from "../constants/journal";
import { DoiParser } from "./parsers/doi-parser";
import RefParser from "./parsers/ref-parser";

const doiParser = new DoiParser();
const parser = new RefParser();

export class RichTextService {
  private static singleton: RichTextService;
  public refCount: number;
  public str: string;
  private setting: Setting;

  constructor() {
    this.refCount = 0;
    this.setting = Setting.instance;
  }

  public generate(str: string) {
    const indexes = this.retrieveSearchIndexes(str);
    const originalLengths = indexes.map(([start, end]) => end - start);
    const referenceStrings = this.retrieveSearchString(str, indexes);
    const trimmedLengths = referenceStrings.map(s => s.length);
    const doiIndexes = doiParser.parseIndex(str);
    const exactPositions = indexes
      .map(([start, end], i) => {
        if (trimmedLengths[i] === 0) {
          return [];
        }
        return [start, end - (originalLengths[i] - trimmedLengths[i])];
      })
      .concat(doiIndexes)
      .reduce((acc, arr) => acc.concat(arr), [])
      .sort((a, b) => a - b);
    this.refCount = exactPositions.length / 2;
    let richText = "";
    let current = exactPositions.shift();
    let isOpeningTag = true;
    for (let i = 0; i < str.length; i++) {
      if (i === current) {
        richText += isOpeningTag
          ? `<a href="#" rel="noreferer noopener" class="pending">`
          : "</a>";
        current = exactPositions.shift();
        isOpeningTag = !isOpeningTag;
      }
      richText += str[i];
    }
    return richText;
  }

  public getRefCount() {
    return this.refCount;
  }

  private retrieveSearchIndexes(str: string, useCommon = true) {
    const useFull = this.setting.getOne("js__useFull");
    const ABBREV_MAP = (!useFull) ? ABBREVIATIONS : ABBREVIATIONS_ALL;
    const indexes = ABBREV_MAP.map(ab => parser.parseIndex(ab, str))
      .reduce((all, arr) => all.concat(arr))
      // 按照 start 位置排序
      .sort(([prevStart, prevEnd], [nextStart, nextEnd]) => {
        let diff = prevStart - nextStart;
        if (diff === 0) {
          diff = prevEnd - nextEnd;
        }
        return diff;
      })
      // 去除是相邻区间子集的元素
      .filter(([start, end], index, arr) => {
        if (index === 0) {
          return true;
        }
        const [prevStart, prevEnd] = arr[index - 1];
        if (prevEnd >= end) {
          return false;
        }
        return true;
      });
    return indexes;
  }

  private retrieveSearchString(str: string, indexes: number[][]) {
    const strings = indexes
      .map(([start, end]) => str.slice(start, end + 1))
      .map(strstr => {
        const removeTailReg = /(?:\[\d*\]|\(\d*\))?\W*$/;
        return strstr.replace(removeTailReg, "").replace(/\D+$/, "");
      });
    return strings;
  }

  public static get instance(): RichTextService {
    if (!RichTextService.singleton) {
      RichTextService.singleton = new RichTextService();
    }
    return RichTextService.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/services/rich-text-service.ts